import * as actionTypes from "../../store/actions";
import { ENVIRONMENT } from "../../config";
import secureStorage from "../../helpers/locStore";

const initialState = {
  isLoggedIn: false,
  userdata: null,
};

const userReducer = (state = initialState, action) => {
  if (ENVIRONMENT === "development") {
    console.log("hit the user reducer");
  }

  switch (action.type) {
    case actionTypes.UPDATE_USERDATA: {
      secureStorage.setItem("userdata", {
        isLoggedIn: action.payload.userdata?.id ? true : false,
        userdata: action.payload.userdata,
      });
      return {
        isLoggedIn: action.payload.userdata?.id ? true : false,
        userdata: action.payload.userdata,
      };
    }

    case actionTypes.LOGOUT: {
      secureStorage.setItem("userdata", {
        isLoggedIn: false,
        userdata: null,
      });
      return {
        isLoggedIn: false,
        userdata: null,
      };
    }
    default:
      return state;
  }
};

export default userReducer;
